// extracted by mini-css-extract-plugin
export default {"subtitle":"styles_subtitle__HoWll","item":"styles_item__5csUh","dueDate":"styles_dueDate__cxOe3","category":"styles_category__2rLKR","separator":"styles_separator__ZXHKU"};